<template>
<header class="navbar">
    <div class="container">
    <div class="navbar-brand">
        <a class="navbar-item" :href="$store.state.baseUrl">
            <span class="mu-font is-size-3 is-uppercase">mucrisis</span>
        </a>
        <a class="navbar-item on-button is-unselectable" v-tooltip="{ content: server.cs && server.gs ? 'Servidor En Línea':'Servidor Apagado' }">
            <fa icon="power-off" :class="['is-size-4 is-unselectable', server.cs && server.gs ? 'has-text-primary':'has-text-danger']" />
        </a>
        <span 
        :class="{'navbar-burger burger back-dark has-text-white':true,'is-active':burger}" 
        data-target="navbarMenuHeroC" 
        @click="$store.commit('ExpandBurger',!burger)">
        <span></span>
        <span></span>
        <span></span>
        </span>
    </div>
    <div id="navbarMenuHeroC" :class="{'navbar-menu':true, 'is-active':burger}">
        <div class="navbar-end">
        <router-link to="/" :class="{'navbar-item has-text-white back-dark is-unselectable':true, 'is-active':currentPage=='home'}">
            <span class="icon"><fa icon="home" /></span> <span>Inicio</span> 
        </router-link>
        <router-link to="/informacion" :class="{'navbar-item has-text-white back-dark is-unselectable':true, 'is-active':currentPage=='about'}">
            <span class="icon"><fa icon="info-circle" /></span> <span>Información</span>
        </router-link>
        <router-link to="/contacto" :class="{'navbar-item has-text-white back-dark is-unselectable':true, 'is-active':currentPage=='contact'}">
            <span class="icon"><fa icon="location-arrow" /></span> <span>Contacto</span>
        </router-link>
        <transition name="slideRight" mode="out-in">
            <a class="navbar-item has-text-white back-success" @click="$emit('register')" v-if="!loggedIn">
                <span class="icon"><fa icon="edit" /></span> <span>Registro</span>
            </a>
            <router-link to="/cuenta" :class="{'navbar-item has-text-white back-info':true, 'is-active':currentPage=='dashboard'}" v-else>
                <span class="icon"><fa icon="user" /></span> <span>{{user.user.username}}</span>
            </router-link>
        </transition>
        <transition name="slideRight" mode="out-in">
            <a class="navbar-item has-text-white back-link" @click="$emit('login')" v-if="!loggedIn">
                <span class="icon"><fa icon="sign-in-alt" /></span> <span>Acceso</span>
            </a>
            <a class="navbar-item has-text-white back-danger" v-else @click="verifyLogout()">
                <span class="icon"><fa icon="sign-out-alt" /></span>
            </a>
        </transition>
        <span class="navbar-item">
            <router-link to="/jugar" class="button is-link is-inverted mu-font is-uppercase">
                <span class="icon">
                    <fa icon="dragon" />
                </span>
                <span>jugar</span>
            </router-link>
        </span>
        </div>
    </div>
    </div>
</header>  
</template>

<script>
import Swal from 'sweetalert2'
export default {
    name:'Navbar',
    props: ['loggedIn','user','currentPage'],
    computed: {
        burger() {
            return this.$store.getters.GetPageMenu.expand
        },
        server() {
            return this.$store.getters.GetServerInfo
        },
    },
    methods: {
        verifyLogout() {
            Swal.fire({
            title: '¿Desea proceder?',
            text: "Estas a un paso de desconectarte.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '¡Si, sacarme de aquí!',
            cancelButtonText: 'No, espera',
            }).then((result) => {
                if (result.value) {
                    this.$emit('logout')
                }
            })
            
        }
    }
}
</script>

<style scoped>
    @media screen and (max-width: 1023px){
        #navbarMenuHeroC {
            position: fixed;
            right:0;
            top:50px;
            width: 50%;
        }
        .navbar-menu {
            transition: display 1s;
        }
    }
    .navbar-item.on-button:hover {
        background:inherit !important;
    }
</style>